import { stringify } from 'query-string';
import { MAX_LIMIT } from 'config';

import { IFrequencyType } from 'components/data-containers/PositionsTable/shared/shared';
import { ChartTypes } from 'types/shared';

import getCountryIds from 'helpers/getCountryIds';

export interface IChartsTracksURLArgs {
  chartIds?: string | string[];
  countryIds?: string | string[];
  productType?: string;
  chartType?: ChartTypes;
  sortBy?: string;
  trackLimit?: number;
  limit?: number;
  offset?: number;
  trackOffset?: number;
  showGrouped?: boolean;
  chartFrequency?: IFrequencyType;
  download?: boolean;
  date?: number;
  sortOrder?: 'asc' | 'desc';
  customerFilter?: string[];
  customRegion?: string | string[];
  region?: string;
}

export default function getChartsTracksURL(args: IChartsTracksURLArgs): string {
  const {
    chartIds,
    chartType,
    countryIds,
    sortBy,
    limit = MAX_LIMIT,
    trackLimit,
    trackOffset,
    offset,
    chartFrequency,
    download,
    date,
    sortOrder,
    customerFilter,
    customRegion,
    region,
  } = args;

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    chartIds,
    chartType,
    sortBy,
    limit,
    offset,
    trackLimit,
    trackOffset,
    chartFrequency,
    download,
    date,
    sortOrder,
    customerFilter,
  });

  return `/api/charts?${params}`;
}
